module.exports = __webpack_public_path__ + "static/media/rls_logo_short.a3753fe6.png";